import useAxiosPrivate from '../../Hooks/useAxiosPrivate';
import { Link, useNavigate} from 'react-router-dom';
import GalleryPageBanner from './GalleryPageBanner';
import { useEffect, useState } from 'react';
import Pagination from '../../Components/Pagination';

const VIEW_GALLERIES_URL = '/galleries';

function Galleries({img, cat}) {
  const axiosPrivate = useAxiosPrivate();

  const [totalPages, setTotalPages] = useState(0);
  const [galleries, setGalleries] = useState([]);
  const [page, setPage] = useState(1);

  const navigate = useNavigate();  
  
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    axiosPrivate.get(VIEW_GALLERIES_URL + '?page=' + page + '&cat=' + cat).then((response) => {
      if(isMounted){
        setGalleries(response.data.docs);
        setTotalPages(response.data.pages);
      }
    }).catch((error) => {
      //Handle Errors Coming out of this
    });
    return () => { isMounted = false; controller.abort();  }
    // eslint-disable-next-line
  }, [page]);

  return (
    <>
      <GalleryPageBanner img={img} cat={cat}/>
      <section id="blog-page" className="pb-30 gray-bg">
        <div className="container">
          <div className="row">
            { galleries.length>0 ?
              <>            
                {galleries.map((value)=>{
                  return (
                    <div key={value.id} className='col-lg-3 mt-30 col-md-6'>
                      <div className='singel-blog' onClick={() => navigate(`/gallery/view/${value.id}`)} style={{cursor: 'pointer'}}>
                        <div className="blog-thum overflow-hidden" style={{height: '200px'}}>
                          <img className="img-fluid w-100 h-100" src={img + value.picture} alt="" style={{objectFit: 'cover'}} loading='lazy'/>
                        </div>   
                        <div className="blog-cont">
                          <Link to={`/gallery/view/${value.id}`}><h4>{value.name}</h4></Link>
                          <ul>
                            <li><Link to='#date'><i className="fa fa-calendar"></i>{new Date(value.createdAt).toDateString()}</Link></li>
                          </ul>
                          <p className="m-0 paraLimit" dangerouslySetInnerHTML={{ __html: value.description}} />
                        </div>
                      </div>
                    </div>
                  );
                })}
                {totalPages>1 &&
                  <div className="col-lg-12">
                    <Pagination totalPages={totalPages} setPage={setPage} page={page} />
                  </div>
                }
              </>              
            :
              <>
                  <div className='contact-from mt-30 mb-300 col-lg-12'>
                    <div className="section-title">
                      <h5>gallery</h5>
                      <h2>Photo Galleries</h2>
                    </div> { /* <!-- section title --> */ }
                    <div className='blog-details pt-45 mb-200'>
                      <p>There are no photos at the moment.<br /><br /></p> <h6><Link to='/'>Return to the Home Page</Link></h6>
                    </div>
                  </div>
              </>
            }
          </div>
        </div>
      </section>
    </>
  )
}

export default Galleries